(function () {
  var CONFIG = {
    enabled: true,

    // 'gst'    → (X% + GST off)
    // 'simple' → (X% off)
    format: 'simple'
  };
  // ─────────────────────────────────────────────────────

  if (!CONFIG.enabled) return;


  var BADGE_STYLE_PRODUCT    = 'color:#22a06b;font-size:1.1rem;font-weight:700;line-height:1.4;';
  var BADGE_STYLE_COLLECTION = 'color:#22a06b;font-size:0.85rem;font-weight:600;line-height:1.3;';

  function label(pct) {
    return CONFIG.format === 'simple'
      ? '(' + pct + '% off)'
      : '(' + pct + '% + GST off)';
  }

  // comparePrice = MRP, salePrice = SP, tax = GST %
  function calcPct(comparePrice, salePrice, tax) {
    comparePrice = parseFloat(comparePrice) || 0;
    salePrice    = parseFloat(salePrice)    || 0;
    tax          = parseFloat(tax)          || 0;
    if (!comparePrice || !salePrice || comparePrice <= salePrice) return 0;

    if (CONFIG.format === 'gst' && tax > 0) {
      // Strip GST from MRP → measure how much SP saves on the base price
      // Base MRP = MRP / (1 + tax/100)
      // x = (Base MRP - SP) / Base MRP × 100
      var baseMrp = comparePrice / (1 + tax / 100);
      if (baseMrp <= salePrice) return 0;
      return Math.round(((baseMrp - salePrice) / baseMrp) * 100);
    }

    // 'simple': raw discount on gross MRP
    // x = (MRP - SP) / MRP × 100
    return Math.round(((comparePrice - salePrice) / comparePrice) * 100);
  }

  // ── Theme cards (product-price.liquid) ───────────────
  function processThemeCards() {
    document.querySelectorAll('[data-price-container][data-tax]').forEach(function (el) {
      var tax = parseFloat(el.dataset.tax || 0);
      if (tax <= 0) return;

      var pct = calcPct(el.dataset.comparePrice, el.dataset.currentPrice, tax);
      if (pct <= 0) return;

      var existing = el.querySelector('.price-gst-off');
      if (existing) {
        existing.textContent = label(pct);
        return;
      }

      var badge = document.createElement('span');
      badge.className = 'price-gst-off d-block mt-2xs';
      badge.style.cssText = BADGE_STYLE_PRODUCT + 'flex-basis:100%;';
      badge.textContent = label(pct);
      el.appendChild(badge);
    });
  }

  // ── Custom product-list carousel cards ───────────────
  function processCarouselCards() {
    document.querySelectorAll('.product-carousel__price[data-tax][data-current-price]').forEach(function (el) {
      var tax = parseFloat(el.dataset.tax || 0);
      if (tax <= 0) return;

      var pct = calcPct(el.dataset.comparePrice, el.dataset.currentPrice, tax);
      if (pct <= 0) return;

      var existing = el.querySelector('.price-gst-off');
      if (existing) {
        existing.textContent = label(pct);
        return;
      }

      var badge = document.createElement('span');
      badge.className = 'price-gst-off';
      badge.style.cssText = BADGE_STYLE_COLLECTION + 'display:block;margin-top:4px;';
      badge.textContent = label(pct);
      el.appendChild(badge);
    });
  }

  // ── Globo Filter cards (collection page) ─────────────
  function processGloboCards() {
    document.querySelectorAll('.grid__item[data-product-id]').forEach(function (card) {
      if (card.dataset.gstDone) return;

      // Tax is emitted per-card (globo.filter.product.liquid) so every card on
      // every page carries its own value — no dependence on a page-scoped map.
      // 'gst' format needs it; 'simple' computes straight from the prices.
      var tax = parseFloat(card.dataset.tax) || 0;
      if (CONFIG.format === 'gst' && tax <= 0) return;

      var pct = calcPct(card.dataset.comparePrice, card.dataset.salePrice, tax);
      if (pct <= 0) return;

      var wrapper = card.querySelector('.spf-product-card__price-wrapper');
      if (!wrapper) return;

      var existing = wrapper.querySelector('.price-gst-off');
      if (existing) { existing.textContent = label(pct); return; }

      var badge = document.createElement('div');
      badge.className = 'price-gst-off';
      badge.style.cssText = BADGE_STYLE_COLLECTION + 'margin-top:4px;';
      badge.textContent = label(pct);
      wrapper.appendChild(badge);
      card.dataset.gstDone = '1';
    });
  }

  // Re-run when theme JS updates price attributes on variant change
  function watchThemePriceSpans() {
    document.querySelectorAll('[data-price-container][data-tax]').forEach(function (el) {
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          return m.attributeName === 'data-current-price' ||
                 m.attributeName === 'data-compare-price';
        });
        if (!relevant) return;
        var tax = parseFloat(el.dataset.tax || 0);
        if (tax <= 0) return;
        var pct = calcPct(el.dataset.comparePrice, el.dataset.currentPrice, tax);
        if (pct <= 0) return;
        var existing = el.querySelector('.price-gst-off');
        if (existing) {
          existing.textContent = label(pct);
        } else {
          var badge = document.createElement('span');
          badge.className = 'price-gst-off d-block mt-2xs';
          badge.style.cssText = BADGE_STYLE_PRODUCT + 'flex-basis:100%;';
          badge.textContent = label(pct);
          el.appendChild(badge);
        }
      }).observe(el, {
        attributes: true,
        attributeFilter: ['data-current-price', 'data-compare-price']
      });
    });
  }

  // Expose so carousel section can call after city-price update
  window.gstBadge = { processCarouselCards: processCarouselCards };

  // Globo fires this when its render (initial + every filter/sort/page change) completes
  window.addEventListener('globoFilterRenderCompleted', processGloboCards);

  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('collectionProductGrid');

    // Always run for carousel sections (present on any page type)
    processCarouselCards();

    if (grid) {
      // Collection page — run immediately in case Globo already rendered
      processGloboCards();
      // Fallback observer in case globoFilterRenderCompleted is missed
      new MutationObserver(function (mutations) {
        var hasProductCard = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (node) {
            if (node.nodeType !== 1) return false;
            if (node.dataset && node.dataset.productId) return true;
            return !!(node.querySelector && node.querySelector('[data-product-id]'));
          });
        });
        if (hasProductCard) processGloboCards();
      }).observe(grid, { childList: true, subtree: true });
      // Safety net: final pass after all resources load
      window.addEventListener('load', processGloboCards);
    } else {
      // Product / other pages — only run theme cards + watch variant changes
      processThemeCards();
      watchThemePriceSpans();
    }
  });
})();